import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Faq from './components/Faq';
import Media from './components/Media';
import AppSection from './components/AppSection';
import Topics from './components/Topics';
import Contact from './components/Contact';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Ranking from './components/Ranking';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Updates />
        <Cards />
        <Comments />
        <Faq />
        <Media />
        <AppSection />
        <Topics />
        <Contact />
        <Features />
        <Carousel />
        <Ranking />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}